import * as THREE from "three";
import { patchArray, decorateArray } from "../../utils/data-utils";

import globalModels from "../global-models";
import seriesModels from "./models.json";

import globalEntities from "../global-entities";
import seriesEntities from "./entities.json";

import globalMaterials from "../global-materials";

import globalTextures from "../global-textures";
import seriesTextures from "./textures.json";
import spots from "./spots";
import { createTimeAnimation, createToggleAnimation } from "../../utils/entity-utils";

let models = [];
let entities = [
  {
    id: "EnviroDome",
    object3D: "EnviroDome",
    parent: "scene",
    transform: {
      position: [1, -0.87, 0],
      rotation: [-Math.PI / 2, 0, Math.PI],
    },
  },
  createTimeAnimation("Valtra_N_Frontloader", "Frontloader_N_Action", "{context.tractor.state.loaderPosition}"),
  createTimeAnimation("Valtra_N_Steering", "Steering_Action", "{context.tractor.state.steeringAngle}"),
  createTimeAnimation("Valtra_N_SteeringWheel", "SteeringWheel_Action", "{context.tractor.state.steeringAngle}"),
  createToggleAnimation("Valtra_N_FrontHook", "Fronthook_Action", "{context.tractor.state.frontLinkageUp}"),

  createToggleAnimation("Valtra_N_Trans", "Trans_Action", "{context.tractor.state.hitchUp}"),
  createToggleAnimation("Valtra_N_Toolbox", "Toolbox_Action", "{context.tractor.state.toolboxOpen}"),
  createToggleAnimation("Valtra_N_DoorR", "DoorR_Action", "{context.tractor.state.doorOpen_R}"),
  createToggleAnimation("Valtra_N_DoorL", "DoorL_Action", "{context.tractor.state.doorOpen_L}"),
  createToggleAnimation("Valtra_N_Seat", "Seat_Action", "{context.tractor.state.seatDown}"),
  createToggleAnimation("Valtra_N_Coolbox", "Coolbox_Action", "{context.tractor.state.coolboxOpen}"),
  createToggleAnimation("Valtra_N_Coolbox_Premium", "Coolbox_Premium_Action", "{context.tractor.state.coolboxOpen}"),
  createToggleAnimation("Valtra_N_Interior_Premium", "Compartment_Premium_Action"  , "{context.tractor.state.hatchOpen}"),
  createToggleAnimation("Valtra_N_Interior", "Compartment_Action" , "{context.tractor.state.hatchOpen}"),
  createToggleAnimation("Valtra_N_SunScreen", "Sunscreen_Action_1", "{context.tractor.state.sunscreenDown}"),
  createToggleAnimation("Valtra_N_SunScreen2", "Sunscreen_Action", "{context.tractor.state.sunscreenDown}"), // Premium
  {
    // Puuttui määritystiedostosta
    id: "M219VV2550307_premium",
    object3D: "M219VV2550307_premium",
    visible: false,
  }, 
  ...spots,
];
let materials = [];
let textures = [];

models = patchArray(patchArray(globalModels, seriesModels), models);
entities = patchArray(patchArray(globalEntities, seriesEntities), entities);
materials = patchArray(globalMaterials, materials);
textures = patchArray(patchArray(globalTextures, seriesTextures), textures);

models = decorateArray(models, { preload: true });
textures = decorateArray(textures, {
  preload: true,
  encoding: THREE.sRGBEncoding,
});

const data = {
  entities,
  models,
  materials,
  textures,
};

process.env.NODE_ENV === "development" && console.log("n-series three", data);

export default data;
